import {EActionStatus} from '@app/shared/enums/action-status.enum';
import {createReducer, on} from '@ngrx/store';
import {IAccountsState} from '../models/accounts.model';
import {ICustomersState} from '../models/customer-state.model';
import {
  customersAction,
  customersEffectError,
  customersEffectFailure,
  customersEffectSuccess,
  loadEditCustomerAccountDetailsSuccess,
  loadRolesSuccess,
  resetAddAccountStatus,
  resetUpdateAccountStatus,
  resetUpdateOrganizationStatus,
  saveAccountFailure,
  saveAccountSuccess,
  updateAccountFailure,
  updateAccountStatus,
  updateAccountSuccess,
  updateAddAccountStatus,
  updateOrganizationSuccess,
} from './accounts.actions';

const initialCustomersState: ICustomersState = {
  status: EActionStatus.Initial,
  successResponse: null,
  failureReason: '',
  errorMessage: '',
};
export const customersReducer = createReducer(
  initialCustomersState,
  on(customersAction, state => ({
    ...state,
    status: EActionStatus.Pending,
  })),
  on(customersEffectSuccess, (state, {response}) => ({
    ...state,
    status: EActionStatus.Success,
    successResponse: response,
  })),
  on(customersEffectFailure, (state, {reason}) => ({
    ...state,
    status: EActionStatus.Failure,
    failureReason: reason,
  })),
  on(customersEffectError, (state, {error}) => ({
    ...state,
    status: EActionStatus.Error,
    errorMessage: error,
  }))
);

const initialState: IAccountsState = {
  medicalSpecialtyInfo: [],
  addAccountStatus: EActionStatus.Initial,
  updateAccountStatus: EActionStatus.Initial,
  deleteAccountStatus: EActionStatus.Initial,
  editCustomerAccountDetails: null,
  updateOrganizationStatus: EActionStatus.Initial,
  roles: [],
};
export const accountsReducer = createReducer(
  initialState,
  on(updateOrganizationSuccess, (state, {status}) => ({
    ...state,
    updateOrganizationStatus: status,
  })),
  on(resetUpdateOrganizationStatus, state => ({
    ...state,
    updateOrganizationStatus: EActionStatus.Initial,
  })),
  on(loadRolesSuccess, (state, {roles}) => ({...state, roles: roles})),
  on(saveAccountSuccess, (state, {status}) => ({
    ...state,
    addAccountStatus: status,
  })),
  on(saveAccountFailure, (state, {status}) => ({
    ...state,
    addAccountStatus: status,
  })),
  on(resetAddAccountStatus, state => ({
    ...state,
    addAccountStatus: EActionStatus.Initial,
  })),
  on(updateAddAccountStatus, (state, {status}) => ({
    ...state,
    addAccountStatus: status,
  })),
  on(updateAccountSuccess, (state, {status}) => ({
    ...state,
    updateAccountStatus: status,
  })),
  on(updateAccountFailure, (state, {status}) => ({
    ...state,
    updateAccountStatus: status,
  })),
  on(resetUpdateAccountStatus, state => ({
    ...state,
    updateAccountStatus: EActionStatus.Initial,
  })),
  on(updateAccountStatus, (state, {status}) => ({
    ...state,
    updateAccountStatus: status,
  })),
  on(loadEditCustomerAccountDetailsSuccess, (state, {editCustomerAccountInfo}) => ({
    ...state,
    editCustomerAccountDetails: editCustomerAccountInfo,
  }))
);
